export default __webpack_public_path__ + "static/media/vue-logo.c9aab136.svg";